/* eslint-disable react/jsx-handler-names */
import { useFormContext } from "react-hook-form";

// Components
import Button from "components/atoms/Button";
import Checkbox from "components/atoms/Checkbox";
import Input, { InputProps } from "components/atoms/Input";

// Containers
import CurrencySelectContainer from "containers/molecules/CurrencySelectContainer";
import CurrencySelectMobileContainer from "containers/molecules/CurrencySelectMobileContainer";

// Helpers
import { getNameError } from "helpers/errors";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "hooks/useTranslate";

// Icons
import ErrorIcon from "assets/icons/banger/error.svg?react";

// Validators
import { RegistrationFormValidation } from "validators/RegistrationForm";

import { useEffect } from "react";
import { useGTM } from "hooks/useGTM";
import EmailInputWrapper from "../EmailInputWrapper";
import OAuthBlock from "../OAuthBlock";
import "./styles.sass";

type RegistrationFormProps = {
  login: string;
  password: string;
  error: string;
  currencyCode: string;
  // eslint-disable-next-line react/no-unused-prop-types
  isAgreementShow?: boolean;
  onChange: (value, props: InputProps) => void;
  onSubmit: (data) => void;
};

const RegistrationForm = (props: RegistrationFormProps) => {
  const {
    login,
    password,
    currencyCode,
    error,
    isAgreementShow = true,
    onChange,
    onSubmit,
  } = props;

  const { isDesktop } = useBreakpoint();

  const GTM = useGTM();

  const t = useTranslate();

  const { formState, handleSubmit } = useFormContext();

  useEffect(() => {
    if (Object.keys(formState.errors).length > 0) {
      Object.entries(formState.errors).forEach(([fieldName, errorObj]) => {
        // @ts-ignore
        GTM.onRegistrationError(fieldName, errorObj?.message || "");
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.submitCount]);

  const isAgeAgreement = Object.keys(formState.errors).includes("ageAgreement");

  const responsedError = error ? "registration.email.error" : "";
  return (
    <form className="RegistrationForm" onSubmit={handleSubmit(onSubmit)}>
      <div className="RegistrationForm__row">
        <EmailInputWrapper
          type="email"
          label={t("registration.email")}
          error={t(getNameError(formState.errors, "login", responsedError))}
          name="login"
          validation={RegistrationFormValidation.login}
          value={login}
          onBlur={onChange}
        />
      </div>
      <div className="RegistrationForm__row">
        <Input
          type="password"
          label={t("registration.password")}
          error={t(getNameError(formState.errors, "password"))}
          name="password"
          validation={RegistrationFormValidation.password}
          value={password}
          onBlur={onChange}
        />
      </div>
      <div className="RegistrationForm__row">
        {isDesktop ? (
          <CurrencySelectContainer />
        ) : (
          <CurrencySelectMobileContainer />
        )}
      </div>

      <div className="RegistrationForm__socials">
        <OAuthBlock type="signUp" currencyCode={currencyCode} />
      </div>

      {isAgreementShow && (
        <>
          <div className="RegistrationForm__checks">
            <Checkbox
              label={`${t("newreg.popup.18")} <a href='/info/conditions' target='_blank'>${t(
                "newreg.popup.agreement",
              )}</a>`}
              mode={
                import.meta.env.VITE_APP_PROJECT_NAME === "banger"
                  ? "dark"
                  : "light"
              }
              error={getNameError(formState.errors, "policyAgreement")}
              name="policyAgreement"
              validation={RegistrationFormValidation.checkboxes}
              checked
              align
            />
          </div>
          {isAgeAgreement ? (
            <div className="RegistrationForm__error">
              <ErrorIcon />
              <span>{t("registration.error")}</span>
            </div>
          ) : null}
        </>
      )}

      <div className="RegistrationForm__button">
        <Button
          htmlType="submit"
          label="login.registration"
          variation="primary"
          // loading={isLoading}
        />
      </div>
    </form>
  );
};

export default RegistrationForm;
